import { Component } from '@angular/core';
import { SecurityService } from 'smarthub-core';

@Component({
    selector: 'main-layout',
    styleUrls: ['./main.layout.scss'],
    template: `
    <nb-layout [center]="false" windowMode>
      <nb-layout-header fixed>
        <ngx-header [position]="'normal'"></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" state="compacted" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="main-content">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})

export class LayoutComponent {

    constructor(public _lanternSecurity: SecurityService) {

    }

}
